<template>
  <div>
    <div class="result-box">
      <img src="@/assets/images/result_ok.png" class="result-icon" />
      <div class="result-text">
        {{ resultText }}
      </div>
      <div class="result-sub-text">
        {{ resultSubText }}
      </div>
    </div>
    <div class="button-box">
      <van-button type="primary" block @click="goDetail">{{
        confirmText
      }}</van-button>

      <van-button style="margin-top: 12px" block @click="goHome"
        >返回首页</van-button
      >
    </div>
  </div>
</template>

<script>
import { BridgeNativeMethods } from "@/assets/js/jsbridge";
import { RESULT_TYPES } from "@/assets/js/config";

export default {
  name: "Result",
  mounted() {
    let params = this.$route.params;
    let { type, extra } = params;
    this.type = type;
    this.extra = JSON.parse(extra);
    this.initView();
  },
  data() {
    return {
      type: "",
      extra: null,
      resultText: "",
      resultSubText: "",
      confirmText: "",
    };
  },
  methods: {
    goDetail() {
      try {
        this.$router.replace({
          name: RESULT_TYPES[this.type].detailRouter,
          params: { id: this.extra.Id },
        });
      } catch (error) {
        console.log(error);
      }
    },
    initView() {
      try {
        let { result, resultSub, confirm } = RESULT_TYPES[this.type];
        this.resultText = result;
        this.resultSubText = resultSub;
        this.confirmText = confirm;
        BridgeNativeMethods.setTitle(result);
      } catch (err) {
        console.log("result type", err);
      }
    },
    goHome() {
      BridgeNativeMethods.navigateHome();
    },
  },
};
</script>

<style lang="less" scoped>
.result {
  &-box {
    padding-top: 32px;
    background: white;
  }
  &-icon {
    display: block;
    width: 64px;
    height: 64px;
    margin: 0 auto;
  }
  &-text {
    line-height: 24px;
    margin-top: 24px;
    font-size: @font-size-lg;
    text-align: center;
  }
  &-sub-text {
    line-height: 20px;
    font-size: @font-size-sm;
    margin-top: 8px;
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 12px;
    text-align: center;

    color: #888888;
  }
}
.button-box {
  margin-left: 16px;
  margin-right: 16px;
  margin-top: 24px;
}
</style>